import http from 'axios'

export const getUsers = ({ cacheKey, page, filterQuery }) => ({
  type: 'USERS/GET_USERS',
  payload: http({
    method: 'GET',
    url: 'api/v1/users',
    params: {
      offset: (page - 1) * 20,
      limit: 20,
      'filter[query]': filterQuery,
    },
  }),
  meta: {
    cacheKey,
  },
})

export const setRoles = ({ userId, roles }) => ({
  type: 'USERS/SET_ROLES',
  payload: http({
    method: 'PUT',
    url: `api/v1/users/${userId}/roles`,
    data: {
      roles,
    },
  }),
  meta: {
    userId,
  },
})



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Users/Users.actions.js